export const localization = {
    Copyright: {
        ru: `© ${new Date().getFullYear()} Все права защищены`,
        en: `© ${new Date().getFullYear()} All rights reserved`,
        kz: `© ${new Date().getFullYear()} Барлық құқықтар қорғалған`,
        link: '#',
    },
    PrivacyPolicy: {
        ru: 'Политика конфиденциальности',
        en: 'Privacy Policy',
        kz: 'Құпиялылық саясаты',
        link: '#',
    },
    UserAgreement: {
        ru: 'Пользовательское соглашение',
        en: 'User Agreement',
        kz: 'Пайдаланушы келісімі',
        link: '#',
    },
    Help: {
        ru: 'Помощь',
        en: 'Help',
        kz: 'Көмек',
        link: '#',
    }
}